<template>
  <div>
    <div v-if="uData && uData.conditions">
      <div class="my-2">
        <div>
          Where is the inflammation?
          <uveitis-dialogs :data="uData" type="locations"></uveitis-dialogs>
        </div>
        <div class="ml-2 d-flex flex-row flex-wrap">
          <v-btn
            v-for="(location, i) in locations"
            :key="'level_' + i"
            x-small
            class="ma-1"
            @click="currentLocation = location"
            :color="currentLocation == location ? 'primary' : ''"
            depressed
          >
            {{ location | titleize }}</v-btn
          >
        </div>
      </div>
      <!-- <v-fade-transition>
        <div class="my-2" v-if="currentLocation == 'anterior'">
          <div>Are the signs/symptoms acute or chronic?</div>
          <div class="ml-2 d-flex flex-row flex-wrap">
            <v-btn
              v-for="(ac, i) in ['acute', 'chronic']"
              :key="'ac_' + i"
              x-small
              class="ma-1"
              @click="acute_chronic = ac"
              :color="acute_chronic == ac ? 'primary' : ''"
              depressed
            >
              {{ ac | titleize }}</v-btn
            >
          </div>
        </div></v-fade-transition
      > -->
      <div v-if="uData && currentLocation && uData.locations[currentLocation]">
        <div class="overline">Labs for Location</div>
        <div class="d-flex flex-row flex-wrap">
          <div
            v-for="(lab, labKey) in uData.locations[currentLocation].labs"
            :key="labKey"
          >
            <div v-if="uData.labs[lab]">
              <!-- {{ uData.labs[lab].name }} -->
              <uveitis-dialogs
                type="lab"
                :slug="uData.labs[lab].slug"
                :data="uData"
              ></uveitis-dialogs>
            </div>
            <div v-else>{{ lab }}</div>
          </div>
        </div>
        <div>
          <div
            v-for="lg in uData.locations[currentLocation].lab_groups"
            :key="'currentLocation' + lg"
          >
            <uveitis-dialogs
              type="lab_group"
              :slug="uData.labGroups[lg].slug"
              :data="uData"
            ></uveitis-dialogs>
            <!-- {{ uData.labGroups[lg].name }} -->
          </div>
        </div>
      </div>
      <div class="overline">Suggested Labs &amp; Tests</div>
      {{ filteredConditions.labs }}
      <div class="overline">Differentials</div>
      <div class="d-flex flex-row flex-wrap" v-if="filteredConditions">
        <v-card
          v-for="dz in filteredConditions.included"
          :key="dz.id"
          width="200"
          class="ma-1 pa-1 pointer"
          flat
          color="#ffefcd"
        >
          <div class="pa-1">
            {{ dz.name }}
            <!-- <div class="caption">{{ dz.location }}</div> -->
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
// import Name from "../dir/file";
import UveitisDialogs from "./UveitisDialogs.vue";

export default {
  name: "UveitisHome",
  components: { UveitisDialogs },
  props: {
    uData: null,
  },
  data: function () {
    return {
      locations: [
        "anterior",
        "intermediate",
        "posterior",
        "panuveitis",
        "scleritis",
      ],
      currentLocation: null,
      acute_chronic: null,
    };
  },
  methods: {},
  computed: {
    filteredConditions: function () {
      let dzObjects = this.uData?.conditions;
      if (!dzObjects) return null;
      let loc = this.currentLocation;
      let dzIndexes = Object.keys(dzObjects);
      let included = [];
      let excluded = [];
      let labs = [];
      dzIndexes.forEach((slug) => {
        const dz = dzObjects[slug];
        let rtn = true;
        if (loc && dz?.location) {
          //   console.log(dz);
          rtn = rtn && dz.location.includes(loc);
        }
        // if (this.acute_chronic)
        //   rtn = rtn && dz.severity.includes(this.acute_chronic);
        if (rtn) included.push(dz);
        else excluded.push(dz);
        if (rtn && dz.labs) labs.push(...dz.labs);
      });
      labs = [...new Set(labs)];
      return { included: included, excluded: excluded, labs: labs };
    },
  },
};
</script>

<style scoped></style>
